module.exports = __webpack_public_path__ + "scripts/magnifying-class.svg?c5eb937b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/magnifying-class.svg
// module id = 1467
// module chunks = 1